import useSettings from "@/hook/useSettings";
import {createCustomTheme} from "@/theme/index";
import {
  CssBaseline,
  ThemeProvider as MuiThemeProvider
} from "@mui/material";
import {useEffect} from "react";
import {useSelector} from "react-redux";

import {dispatch} from "@/redux/store";
import {updateTheme, updateThemeOptions, startLoading, stopLoading} from "../redux/slices/theme";
import {useAsyncEffect} from "ahooks";
import {getThemeColors} from "@/services";

const ThemeProvider = ({children}) => {
  const {settings} = useSettings();
  // console.log("打印全局设置setting",settings)
  const {themeOptions} = useSelector((state) => state.theme);

  useAsyncEffect(async () => {
    dispatch(startLoading())
    const colors = await getThemeColors()
    dispatch(stopLoading())
    dispatch(updateThemeOptions(colors))
  }, [])

  useEffect(() => {
    let _theme;
    const paramObj = {
      theme: settings.theme,
      direction: settings.direction,
      responsiveFontSizes: settings.responsiveFontSizes,
    }
    if (themeOptions) {
      _theme = createCustomTheme(paramObj, themeOptions);
    } else {
      _theme = createCustomTheme(paramObj);
    }
    dispatch(updateTheme(_theme));
  }, [themeOptions, settings.theme, settings.direction]);

  const {themeObject} = useSelector((state) => state.theme);
  if (!themeObject?.palette) return null;

  return (
    <MuiThemeProvider theme={themeObject}>
      <CssBaseline/>
      {children}
    </MuiThemeProvider>
  )
}

export default ThemeProvider